import { LoaderSpinnerComponent } from '@aston/foundation/components';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { NgClass, AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { delay, of } from 'rxjs';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

import * as NewAccountStoreSelectors from '../../../root-store/new-account-store/selectors';
import { NewAccountStoreActions } from '../../../root-store/new-account-store';
import { AppStoreSelectors } from '../../../root-store/app-store';
import * as RoutesDefinitions from '../../../routes-definitions';
import { AppConfiguration } from '../../../app.configuration';

@Component({
	selector: 'new-account-validation-page',
	templateUrl: './new-account-validation-page.component.html',
	imports: [NgClass, LoaderSpinnerComponent, TranslateDirective, RouterLinkActive, RouterLink, AsyncPipe, TranslatePipe]
})
export class NewAccountValidationPageComponent {

	private config = inject(AppConfiguration);
	private store = inject(Store);

	subsidiaryIsNotReady$ = this.store.select(NewAccountStoreSelectors.selectIsSubsidiaryNotInitialized);
	selectedSubsidiary$ = this.store.select(NewAccountStoreSelectors.selectSelectedSubsidiarySlice);
	currentUserIsSupport$ = this.store.select(AppStoreSelectors.selectCurrentUserIsSupport);
	subscriptionFormError$ = this.store.select(NewAccountStoreSelectors.selectSubscriptionFormError);
	aMinutePassed$ = of(true).pipe(delay(60_000));

	subsListList = RoutesDefinitions.getSubsidiariesFullPath();
	assetsPath = this.config.appRootUrl;

	goToTenant(path = '') {
		this.store.dispatch(NewAccountStoreActions.RedirectToCreatedTenant({ path }));
	}

	subsidiaryDetailUsersPath(subsidiaryId: number) {
		return RoutesDefinitions.getSubsidiaryDetailUsersFullPath(subsidiaryId);
	}
}
